<h2 mat-dialog-title>Story op {{ device?.name }}</h2>
<mat-dialog-content class="mat-typography">
  <button mat-raised-button (click)="close()">Close</button>
</mat-dialog-content>
